import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { SuggestionItemType } from '../magic.types.js';
import { forwardRef } from 'react';
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion';
import { useMagicSuggestionsContext } from './MagicSuggestionsContext.js';
import { IconShock, ImgFolder } from '@fabric-app/icons/old';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { P } from '@fabric-app/ui/components/Typography';

const MagicSuggestionWrapper = styled(motion(Flex)).attrs((p) => {
  return {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    gap: "element",
    ...p
  };
}).withConfig({
  displayName: "MagicSuggestions__MagicSuggestionWrapper",
  componentId: "sc-947dc69a-0"
})([
  `width:100%;padding:0 8px;`
]);
const MagicSuggestionList = styled(motion(Flex)).attrs((p) => {
  return {
    gap: "element",
    flexWrap: "wrap",
    layout: true,
    layoutRoot: true,
    ...p
  };
}).withConfig({
  displayName: "MagicSuggestions__MagicSuggestionList",
  componentId: "sc-947dc69a-1"
})([
  ``
]);
const MagicSuggestionIcon = styled.div.attrs((p) => {
  return {
    children: /* @__PURE__ */ jsx(IconShock, {}),
    ...p
  };
}).withConfig({
  displayName: "MagicSuggestions__MagicSuggestionIcon",
  componentId: "sc-947dc69a-2"
})([
  `width:1.5rem;height:1.5rem;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;color:`,
  `;`
], cssVar["color-text-tertiary"]);
const MagicSuggestionItem = styled(motion.button).attrs((p) => {
  return {
    layout: true,
    initial: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    type: "button",
    ...p
  };
}).withConfig({
  displayName: "MagicSuggestions__MagicSuggestionItem",
  componentId: "sc-947dc69a-3"
})([
  `user-select:none;border:1px dashed `,
  `;border-radius:`,
  `;padding:5.5px 10px;transition:opacity 0.2s;display:flex;align-items:center;gap:0.375rem;&:hover{opacity:0.8;}`
], cssVar["color-bg-senary"], cssVar["radius-input"]);
const MagicSuggestionText = styled(P).attrs((p) => {
  return {
    as: "span",
    size: "xxs",
    color: "quaternary",
    weight: 500,
    ...p
  };
}).withConfig({
  displayName: "MagicSuggestions__MagicSuggestionText",
  componentId: "sc-947dc69a-4"
})([
  ``
]);
const FolderIcon = styled.img.attrs((p) => {
  return {
    alt: "Folder",
    ...p,
    src: ImgFolder
  };
}).withConfig({
  displayName: "MagicSuggestions__FolderIcon",
  componentId: "sc-947dc69a-5"
})([
  `width:16px;height:auto;`
]);
const MagicSuggestions = /* @__PURE__ */ forwardRef(({ disabled = false, ...props }, ref) => {
  const { onSelectSuggestion, suggestions, listHash } = useMagicSuggestionsContext();
  const visible = Boolean(suggestions?.length && !disabled);
  return /* @__PURE__ */ jsx(AnimatePresence, {
    mode: "popLayout",
    children: visible && /* @__PURE__ */ jsxs(MagicSuggestionWrapper, {
      ref,
      ...props,
      children: [
        /* @__PURE__ */ jsx(MagicSuggestionIcon, {}),
        /* @__PURE__ */ jsx(LayoutGroup, {
          children: /* @__PURE__ */ jsx(MagicSuggestionList, {
            children: /* @__PURE__ */ jsx(AnimatePresence, {
              children: suggestions?.map((el) => /* @__PURE__ */ jsxs(MagicSuggestionItem, {
                onClick: () => onSelectSuggestion(el),
                children: [
                  /* @__PURE__ */ jsx(MagicSuggestionText, {
                    children: el.type === SuggestionItemType.FOLDER ? /* @__PURE__ */ jsx(FolderIcon, {}) : "#"
                  }),
                  /* @__PURE__ */ jsx(MagicSuggestionText, {
                    children: el.name
                  })
                ]
              }, el.id ?? el.name))
            })
          })
        })
      ]
    }, `magic-suggestion-list-${listHash}`)
  });
});
MagicSuggestions.displayName = "MagicSuggestions";

export { MagicSuggestions };
//# sourceMappingURL=MagicSuggestions.js.map
